import {createErrorHandlingThunk} from "../../../auth/redux/utils";
import {OrdersService} from "./OrderService";
import {CreateOrderData, FeOrder, UpdateOrderInput, UpdateOrderResult} from "./types";

const orderService = new OrdersService();

export const createOrderThunk = createErrorHandlingThunk<FeOrder, CreateOrderData>(
    'orders/create',
    (dto) => orderService.createOrder(dto)
);

export const updateOrderThunk = createErrorHandlingThunk<UpdateOrderResult, { id: string, dto: UpdateOrderInput }>(
    'orders/update',
    (args) => orderService.updateOrder(args.id, args.dto)
);

export const listOrdersThunk = createErrorHandlingThunk(
    'orders/list',
    () => orderService.listOrders()
);

export const listClientOrders = createErrorHandlingThunk<FeOrder[], { clientId: string }>(
    'orders/client/list',
    (args) => orderService.listClientOrders(args.clientId)
)

export const listWorkerOrders = createErrorHandlingThunk<FeOrder[], { workerId: string, timeRange?: { start: number, end: number } }>(
    'orders/worker/list',
    async (args) => (await orderService.listWorkerOrders(args.workerId, args.timeRange)).filter((o) => !o.cancellation)
);

export const getOrderThunk = createErrorHandlingThunk<FeOrder, { id: string }>(
    'orders/get',
    (args) => orderService.getOrder(args.id)
);

export const getOrderLastOrderOfClientThunk = createErrorHandlingThunk<FeOrder | undefined, { clientId: string }>(
    'orders/getLastOfClient',
    (args) => orderService.getLastOrderOfClient(args.clientId)
);

export const cancelOrderThunk = createErrorHandlingThunk<UpdateOrderResult, { id: string, reason: string, type: "admin" | "worker" }>(
    'order/cancel',
    (args) => orderService.cancelOrder({
        orderId: args.id,
        cancellation: {
            canceledAt: new Date().getTime(),
            reason: args.reason,
            type: args.type
        }
    })
)
